import { createBrowserRouter } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Contact from './pages/Contact';

// Error boundary component for handling route errors
import React from 'react';

const ErrorBoundary: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
        <h1 className="text-3xl font-bold text-primary-700 mb-4">Napaka</h1>
        <p className="text-accent-700 mb-6">
          Prišlo je do napake pri nalaganju strani. Prosimo, poskusite znova.
        </p>
        <a 
          href="/"
          className="btn-primary inline-block"
        >
          Nazaj na domačo stran
        </a>
      </div>
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'o-nas',
        element: <About />,
      },
      {
        path: 'izdelki',
        element: <Products />,
      },
      {
        path: 'kontakt',
        element: <Contact />,
      },
    ],
  },
]);

export default router;